<template>
  <div>
    <div v-if="bookedSuccessfully" class="confirmation">
      {{ $t("subscriptionConfirmText") }}
    </div>
    <div v-else-if="subscriptionTrial" class="container">
      <div v-if="organizationId" class="box">
        <div class="title is-5">
          {{ $t("trialConfirmBtnText") }}
        </div>
        <b-button class="pay-btn" type="is-dark" @click="onConfirmTrialSubscription">Confirm</b-button>
      </div>
    </div>
    <div v-else class="container">
      <div v-if="organizationId" class="box">
        <div class="title is-5">{{ $t("orderSummary") }}</div>
        <b-table class="custom-table has-background-color-dark" :data="tableData" :columns="tableColumns"></b-table>
        <div class="title is-5" style="text-align: center">
          {{ $t("selectOrAddPaymentMethod") }}
        </div>
        <PaymentTypePicker
          v-model="paymentMethod"
          class="payment-picker"
          :organization-id="organizationId"
          :is-subscription-event="false"
          :is-subscription-booking="subscriptionBookingOngoing"
          @selectedPaymentMethod="setSelectedPaymentMethod"
        />
        <b-button class="pay-btn" type="is-dark" :loading="payBtnLoading" @click="createNbxContract"
          >Confirm and Pay</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db, functions } from "@/firebase";
// import { db } from "@/firebase";

import { VAT_COUNTRY_LIST } from "@/env";
import PaymentTypePicker from "@/components/PaymentTypePicker";

export default {
  name: "SubscriptionBooking",
  components: {
    PaymentTypePicker,
  },
  data() {
    return {
      selectedPaymentMethod: undefined,
      subscriptionBookingOngoing: true,
      organizationId: sessionStorage.organizationId,
      payBtnLoading: false,
      bookedSuccessfully: false,
      vatValue: 0.0,
      orgCollection: [],
    };
  },
  computed: {
    ...mapState({
      subscriptionDetails: (state) => state.subscriptionDetails,
      subscriptionTrial: (state) => state.subscriptionTrial,
    }),
    price() {
      if (this.subscriptionDetails.billInterval == "12") {
        return parseFloat(this.subscriptionDetails.amount).toFixed(2);
      } else {
        return parseFloat(this.subscriptionDetails.amount).toFixed(2);
      }
    },
    totalPrice() {
      let vat = parseFloat(this.price) * this.vatValue;
      return (parseFloat(this.price) + vat).toFixed(2);
    },
    organizationDoc() {
      return db.doc(`organizations/${sessionStorage.organizationId}`);
    },
    tableData() {
      return [
        {
          plan: this.subscriptionDetails.plan,
          type: this.subscriptionDetails.type,
          maxUsers: this.subscriptionDetails.maxUser,
          maxLang: this.subscriptionDetails.maxLang,
          price: this.subscriptionDetails.currency === "USD" ? `$${this.price}` : `€${this.price}`,
          vat: `${this.vatValue * 100} %`,
          total: this.subscriptionDetails.currency === "USD" ? `$${this.totalPrice}` : `€${this.totalPrice}`,
        },
      ];
    },
    tableColumns() {
      return [
        {
          field: "plan",
          label: this.$t("plan"),
          width: "40",
        },
        {
          field: "type",
          label: this.$t("type"),
          // width: "40"
        },
        {
          field: "maxUsers",
          label: this.$t("maxUsers"),
        },
        {
          field: "maxLang",
          label: this.$t("maxLangs"),
        },
        {
          field: "price",
          label: this.subscriptionDetails.billInterval === "1" ? this.$t("monthlyPrice") : this.$t("yearlyPrice"),
        },
        {
          field: "vat",
          label: this.$t("vatValue"),
        },
        {
          field: "total",
          label: this.$t("sum"),
        },
      ];
    },
    paymentMethod: {
      get() {
        return this.$store.state.draft.paymentMethod;
      },
      set(value) {
        if (value == "inAdvance" || value == "invoice") {
          this.$store.commit("SET_DRAFT_FIELD", ["paymentMethod", value]);
        } else if (value.id) {
          this.$store.commit("SET_DRAFT_FIELD", ["paymentMethod", "mandate"]);
          this.$store.commit("SET_DRAFT_FIELD", ["mandateId", value.id]);
        }
      },
    },
  },
  watch: {
    organizationId(newVal) {
      console.log("File: SubscriptionBooking.vue, organizationId watcher", newVal);
    },
  },
  async created() {
    this.vatValue = await this.getVatValue();
    console.log("File: SubscriptionBooking.vue, subscriptionDetails:   ", this.subscriptionDetails);
  },
  methods: {
    // Saves booked subscription details to firetore organization
    async onConfirmTrialSubscription() {
      console.log(await this.isTrialEligible());
      if (await this.isTrialEligible()) {
        let orgDocRef = await db.collection("organizations").doc(this.organizationId);

        // Setting trial subscription details to firestore
        await orgDocRef.set(
          {
            trialSubscription: {
              start: Date.now(),
              end: Date.now() + 518400000,
              used: true,
            },
          },
          { merge: true },
        );
        const doc = await orgDocRef.get();
        console.log("trial subscriptionDetails", doc.data().trialSubscription);
        this.$store.commit("set_subscriptionTrial", false);
        this.bookedSuccessfully = true;
      } else {
        alert("Trial already used. Please buy a subscription plan.");
      }
    },
    async isTrialEligible() {
      let orgDocRef = await db.collection("organizations").doc(this.organizationId);
      const doc = await orgDocRef.get();
      const trialSubscription = doc.data().trialSubscription;
      if (trialSubscription && trialSubscription.used) {
        return false;
      } else {
        return true;
      }
    },
    async createNbxContract() {
      if (this.selectedPaymentMethod) {
        console.log("function called", this.selectedPaymentMethod);
        console.log(
          "File: SubscriptionBooking.vue, Plan ID:   ",
          this.generateNbxPlanId(this.subscriptionDetails.currency),
        );
        // Activatying btn loading
        this.payBtnLoading = true;
        try {
          const res = await functions.httpsCallable("CreateNbxContract")({
            organizationId: this.organizationId,
            mollieCustomerId: this.selectedPaymentMethod.customerId,
            nbxPlanIdent: this.generateNbxPlanId(this.subscriptionDetails.currency),
            subscriptionDetails: this.subscriptionDetails,
          });
          console.log("File: SubscriptionBooking.vue, res: ", res.data.success);
          if (res.data.success) {
            this.bookedSuccessfully = res.data.success;
          }
        } catch (error) {
          console.error("File: SubscriptionBooking.vue", error);
        }
        this.payBtnLoading = false;
      } else {
        this.$buefy.toast.open({
          duration: 1000,
          message: "Please select a payment method first!",
          type: "is-danger",
        });
      }
      this.subscriptionBookingOngoing = false;
    },
    setSelectedPaymentMethod(value) {
      // console.log("value", value);
      this.selectedPaymentMethod = value;
    },
    generateNbxPlanId() {
      if (this.subscriptionDetails.currency === "EUR") {
        console.log("File: SubscriptionBooking.vue, Currency:   ", this.subscriptionDetails.currency);
        if (this.subscriptionDetails.plan === "basic" && this.subscriptionDetails.type === "onlineMeeting") {
          return `04_OM1_Basic_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "basic" && this.subscriptionDetails.type === "liveStreaming") {
          return `04_LS1_Basic_${this.subscriptionDetails.maxLang}_0_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "basic" && this.subscriptionDetails.type === "combined") {
          return `04_CM1_Basic_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "premium" && this.subscriptionDetails.type === "onlineMeeting") {
          return `04_OM2_Premium_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "premium" && this.subscriptionDetails.type === "liveStreaming") {
          return `04_LS2_Premium_${this.subscriptionDetails.maxLang}_0_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "premium" && this.subscriptionDetails.type === "combined") {
          return `04_CM2_Premium_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "pro" && this.subscriptionDetails.type === "onlineMeeting") {
          return `04_OM3_Pro_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "pro" && this.subscriptionDetails.type === "liveStreaming") {
          return `04_LS3_Pro_${this.subscriptionDetails.maxLang}_0_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "pro" && this.subscriptionDetails.type === "combined") {
          return `04_CM3_Pro_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        }
      } else if (this.subscriptionDetails.currency === "USD") {
        console.log("File: SubscriptionBooking.vue, Currency:   ", this.subscriptionDetails.currency);
        if (this.subscriptionDetails.plan === "basic" && this.subscriptionDetails.type === "onlineMeeting") {
          return `04_OM1_Basic_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "basic" && this.subscriptionDetails.type === "liveStreaming") {
          return `04_LS1_Basic_${this.subscriptionDetails.maxLang}_0_12m_${this.subscriptionDetails.billInterval}m_EUR`;
        } else if (this.subscriptionDetails.plan === "basic" && this.subscriptionDetails.type === "combined") {
          return `04_CM1_Basic_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "premium" && this.subscriptionDetails.type === "onlineMeeting") {
          return `04_OM2_Premium_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "premium" && this.subscriptionDetails.type === "liveStreaming") {
          return `04_LS2_Premium_${this.subscriptionDetails.maxLang}_0_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "premium" && this.subscriptionDetails.type === "combined") {
          return `04_CM2_Premium_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "pro" && this.subscriptionDetails.type === "onlineMeeting") {
          return `04_OM3_Pro_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "pro" && this.subscriptionDetails.type === "liveStreaming") {
          return `04_LS3_Pro_${this.subscriptionDetails.maxLang}_0_12m_${this.subscriptionDetails.billInterval}m_USD`;
        } else if (this.subscriptionDetails.plan === "pro" && this.subscriptionDetails.type === "combined") {
          return `04_CM3_Pro_${this.subscriptionDetails.maxLang}_${this.subscriptionDetails.maxUser}_12m_${this.subscriptionDetails.billInterval}m_USD`;
        }
      }
    },
    async getVatValue() {
      let organizationData = await this.organizationDoc.get();
      console.log("File: SubscriptionBooking.vue, orgID from storage: ", sessionStorage.organizationId);
      console.log("File: SubscriptionBooking.vue, organizationData", organizationData.data().legalCountry);
      if (
        VAT_COUNTRY_LIST.includes(organizationData.data().legalCountry.toUpperCase()) &&
        organizationData.data().legalCountry !== "de"
      ) {
        return (0.0).toFixed(2);
      }
      if (organizationData.data().legalCountry === "de") {
        return (0.19).toFixed(2);
      }
      return (0.0).toFixed(2);
    },
  },
  firebase: {
    orgCollection: db.collection("organizations"),
  },
};
</script>
<style lang="scss" scoped>
.title.is-5 {
  font-size: 1.1rem;
}
.pay-btn {
  margin-top: 1rem;
  min-width: 223px;
}
.container {
  justify-content: center;
  display: flex;
}
.box {
  // width: 700px;
  // height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: linear-gradient(225deg, #b6e6e48f 0%, #ccccccb8 50%, #b6e6e48f 100%);
}
.spacer {
  height: 200px;
  width: 300px;
}
.dropdown {
  width: 100%;
}
.dropdown.button {
  width: 100%;
}
.spacer-line {
  // background-color: #c1e2a4;
  // display: block;
  // height: 1.5px;
  margin: 0;
  border: 0;
  border-top: 1px solid #c6e1a6;
}
.custom-table {
  // margin-top: 1rem;
  margin-bottom: 1rem;
}
.custom-table {
  ::v-deep table {
    background-color: #ffffffa6;
    border: 1px solid #00000052;
  }
}
.payment-picker {
  ::v-deep button {
    background-color: #abc5c942;
  }
}
</style>
